var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from './Select';
import { SelectAutocomplete } from './SelectAutocomplete';
export { Item as SelectItem, Section as SelectSection, } from '@react-stately/collections';
export const SelectWrapper = (_a) => {
    var { autocomplete = true, disabled, defaultValue, onChange, labelOption = 'default' } = _a, props = __rest(_a, ["autocomplete", "disabled", "defaultValue", "onChange", "labelOption"]);
    return autocomplete ? (_jsx(SelectAutocomplete, Object.assign({ isDisabled: disabled, 
        // TODO: v6 - onChange should accept null as parameter
        // @ts-expect-error key is not correctly inferable
        onSelectionChange: (key) => onChange === null || onChange === void 0 ? void 0 : onChange(key === null || key === void 0 ? void 0 : key.toString()), defaultSelectedKey: defaultValue, labelOption: labelOption }, props))) : (_jsx(Select, Object.assign({ isDisabled: disabled, onSelectionChange: (key) => onChange === null || onChange === void 0 ? void 0 : onChange(key === null || key === void 0 ? void 0 : key.toString()), defaultSelectedKey: defaultValue, labelOption: labelOption }, props)));
};
